export default __webpack_public_path__ + "static/media/chatbots.2467e830.png";